import { AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE } from "../../../utils/artefacts";

export function dataflowIsNotProduction(dataflow) { 

    let isNotProductionDataflow = false;
    const notProductionAnnotation =   [...(dataflow.annotations || []), ...(dataflow.autoAnnotations || [])]
    .find((ann) => (ann && ((ann.type || "").toLowerCase() === AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE.toLowerCase())));
    
    if (notProductionAnnotation) {
      const text = notProductionAnnotation.text;
      if (text && text["en"]) {
          isNotProductionDataflow = true;
      }
    }

    return isNotProductionDataflow;
}


